(function (seraphicProduct, $, undefined) {
	//-----------------------------------------
	// Namespaced Functions
	//-----------------------------------------
    seraphicProduct.showHidePrice = function() {
        //console.log("got here");
        var productPriceContainer = $(".ProductPriceContainer");
        //console.log("test" + $("input.VariantRadioButton").length);
        var hasSubscription = $("input.VariantRadioButton:checked").attr("data-hassubscription");
        //console.log(hasSubscription);
        if (typeof hasSubscription == "undefined" || hasSubscription == "false")
            productPriceContainer.show();
        else
            productPriceContainer.hide();
        return false;
    }

    //-----------------------------------------
	// On Load/Refresh
	//-----------------------------------------
    $(document).ready(function() {
   		var currentTemplate = $("#CurrentTemplate").val();
        if (currentTemplate == "product" || currentTemplate == "page.gut-campaign-landing" || currentTemplate == "page.pet-campaign-landing" || currentTemplate == "page.skin-campaign-landing") {
            var draggableSlide = $("#DraggableSlide");

            draggableSlide.resizable({
                handleSelector: ".SlideHandle svg",
                //handles: { 'e': $(".SlideHandle") },
                containment: ".ProductScienceImage",
                resizeHeight: false,
                minWidth: 0,
                grid: [1, 10000],
                create: function( event, ui ) {
                   draggableSlide.css("width", (draggableSlide.width() / 2) + 2);
                }
            });
        }
        seraphicProduct.showHidePrice();

        // code to hide add to cart button on page load
        // only run if button is not already disabled
        var addToCartButton = $(".AddToCart");
        if ($(addToCartButton).attr("data-variantnull") == "false" && $(addToCartButton).attr("data-available") == "true") {
            var currentVariantId = $("#hdnVariantId").val();
            var disableSingleVariant = $(".VariantOccurrence[data-variant='" + currentVariantId +"']").attr("data-disable");
            var addToCartButtonText = $(".AddToCart span");
            //console.log(currentVariantId + " - " + disableSingleVariant);
    
            if (disableSingleVariant == "true") {
                addToCartButton.attr("disabled", "disabled");
                addToCartButtonText.html("Max quantity reached");
            }
            else {
              addToCartButton.removeAttr('disabled');
              addToCartButtonText.html(addToCartButtonText.attr("data-defaulttext"));
            }
        }
    });

  	//-----------------------------------------
	// Events/Watchers
	//-----------------------------------------
    //$(document).on("change", $("input[type=radio][name=purchase_type]"), function() {
    //    seraphicProduct.showHidePrice();
    //});

  	$(document).on("change", "#hdnVariantId", function() {
        seraphicProduct.showHidePrice();
    });

    $(document).on("click", ".MarqueePauseButton", function() {
        var marqueeInner = $(".TestimonialsMarquee");
      
        marqueeInner.toggleClass("AnimationPause");
        if (marqueeInner.hasClass("AnimationPause"))
            $(this).html("Play");
        else
            $(this).html("Pause");
    });
  
    $(document).on("keypress", ".MarqueePauseButton", function (e) {
        var key = e.which;
        if (key == 13) {
            $(this).click();
        }
        return false;  
    });
} (window.seraphicProduct = window.seraphicProduct || {}, jQuery));
